import { Application } from "shared/types/application";

import { CreditCard01, Logout01, Shield01 } from "untitledui-js-base";

import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";

import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";
import { useNavigate } from "react-router-dom";
import { VerificationNames } from "shared/types";
import { cx } from "shared/utils";
import { getApplicantRole } from "utils/getApplicantRole";

export const SkippedReportsOverview = ({
  requiresManualExecution,
  onClose,
  applicationId
}: {
  onClose?: () => void;
  applicationId?: number;
  requiresManualExecution: Application["requires_manual_or_conditional_execution"];
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex gap-4">
        <InfoIcon className="w-6 text-primary-500" />
        <div className="space-y-1">
          <p className="text-content-1000 font-bold text-base">
            Please note that the following reports have not been run:
          </p>
          <p className="text-content-400 font-normal text-sm">
            Reports have not been run because they are set up to run manually or
            conditionally
          </p>
        </div>
      </div>

      <div className="mt-4 w-full pl-10">
        {requiresManualExecution?.applicants?.map((applicant, idx) => {
          return (
            <div
              className={cx(
                "flex gap-4 items-center py-4 md:flex-nowrap flex-wrap",
                idx > 0 ? "border-t border-alpha-40" : ""
              )}
              key={applicant.name + applicant.role}
            >
              <div className="flex flex-grow flex-col gap-1">
                <p className="text-content-1000 font-medium text-sm truncate">
                  {applicant.name}
                </p>
                <p className="text-content-400 font-normal text-sm">
                  {getApplicantRole(applicant.role)}
                </p>
              </div>

              <div className="flex gap-2">
                <Show
                  if={applicant.verifications.some(
                    (el) => el.name === VerificationNames.CreditReport
                  )}
                >
                  <Button
                    size={ButtonSize.SM}
                    Icon={CreditCard01}
                    onClick={() => {
                      onClose?.();
                      navigate(
                        `/applications/${applicationId}/reports?applicantId=${applicant.id}&report=credit_report`
                      );
                    }}
                  >
                    Credit report
                  </Button>
                </Show>

                <Show
                  if={applicant.verifications.some(
                    (el) => el.name === VerificationNames.CriminalReport
                  )}
                >
                  <Button
                    size={ButtonSize.SM}
                    Icon={Shield01}
                    onClick={() => {
                      onClose?.();
                      navigate(
                        `/applications/${applicationId}/reports?applicantId=${applicant.id}&report=criminal_report`
                      );
                    }}
                  >
                    Criminal report
                  </Button>
                </Show>

                <Show
                  if={applicant.verifications.some(
                    (el) => el.name === VerificationNames.EvictionReport
                  )}
                >
                  <Button
                    size={ButtonSize.SM}
                    Icon={Logout01}
                    variant={ButtonVariant.BASE}
                    onClick={() => {
                      onClose?.();
                      navigate(
                        `/applications/${applicationId}/reports?applicantId=${applicant.id}&report=eviction_report`
                      );
                    }}
                  >
                    Housing court report
                  </Button>
                </Show>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
